import angular from 'angular';
import { DateResolver } from './date-resolver';
import { LocaleResolver } from './locale-resolver';
import { LocalDateResolver } from './local-date-resolver';
import { LocalDateTimeResolver } from './local-date-time-resolver';
import { LocalizationModule } from '@buildium/angularjs-core/dist/localization';
import {DateTimeLocalizationUtilities} from './date-time-localization-utilities';

export const ManagerLocalizationModule = angular.module('buildium.manager.localization', [
    LocalizationModule.name
])
    .factory('Locale', LocaleResolver)
    .filter('bdDate', DateResolver)
    .filter('bdLocalDate', LocalDateResolver)
    .filter('bdLocalDateTime', LocalDateTimeResolver)
    .service('DateTimeLocalizationUtilities', DateTimeLocalizationUtilities);
